import URLs from '@/scripts/request/URLs';
import type { ChatCategory } from '@/contexts/chat/scripts/hooks/useChats/types';
import { myClientStorage } from '@/scripts/utils';
import { MyError } from '@/scripts/extends';
import { userApis } from '../user';

export const commonApis = {
  getSocket() {
    const token = userApis.getToken();
    if (token) {
      return new WebSocket(new URLs.WS('/api/v1/ws', { token }));
    }
  },
  getSequence(type: ChatCategory, serverSequence?: number) {
    return myClientStorage
      .getItem<number>('sequence_' + type)
      .then((sequence) => sequence || 0)
      .then((sequence) => {
        if (serverSequence === undefined || sequence < serverSequence) {
          return sequence;
        }
        throw new MyError({
          message: 'Sequence is old.',
          code: 'SEQUENCE_IS_OLD',
        });
      });
  },
  setSequence(type: ChatCategory, sequence: number) {
    return myClientStorage.setItem('sequence_' + type, sequence);
  },
  setUserPackage({
    type,
    userId,
    keyPackage,
  }: {
    type: 'group' | 'single';
    userId: string;
    keyPackage: string;
  }) {
    return myClientStorage.setItem(`keyPackage_${type}_${userId}`, keyPackage);
  },
  getUserPackage({ userId, type }: { userId: string; type: 'group' | 'single' }) {
    return myClientStorage.getItem(`keyPackage_${type}_${userId}`);
  },
};
